import { gql } from 'graphql-tag';

export const GET_DISCOUNT_DETAILS = gql`
  query discountDetails($promoCode: String!, $external: Boolean!) {
    discountDetails(promoCode: $promoCode, external: $external) {
      actor
      promoID
      name
      amount
      type
      external
      status
      validLocations
      validSkus
      formattedBanner
      bookingValidFrom
      bookingValidTo
    }
  }
`;
